import EleTableHead from './EleTableHead.vue'
import tableColumn from "@/mixins/table/column"

export default {
    name: 'list-data',
    mixins: [tableColumn],
    components: { EleTableHead },
    data() {
        return {
            fullHeight: document.documentElement.clientHeight - 200, //获取页面高度
            batch_flag: true, // 符合批量删除为true,否则为false
            batch_datas: [],
            batch_ids: [],
            batch: {
                flag: true,
                datas: [],
                ids: []
            },
            name: this.DataGrid.name || '',
            toolbar: this.DataGrid.ToolBar || [], //工具栏
            list: this.DataGrid.List || [], // 列表数组
            fieldWidth: [],
            fields: this.DataGrid.FieldList || [], // 字段数组
            expand: this.DataGrid.Expand || false, // 折叠
            checkbox: this.DataGrid.Checkbox !== false ? true : this.DataGrid.Checkbox, //是否显示复选框
            tablesize: this.DataGrid.tablesize, //table 大小
            pagination: this.DataGrid.Pagination || {}, // 分页
            search: this.DataGrid.Search, // 搜索
            showSummary: this.DataGrid.ShowSummary, //是否显示合计行
            showSummaryMethod: this.DataGrid.ShowSummaryMethod, //合计方法
            headerCellClassMethod: this.DataGrid.headerCellClassMethod, //表头单元格类名方法
            rowClassMethod: this.DataGrid.rowClassMethod, //行类名方法
            cellClassMethod: this.DataGrid.cellClassMethod, //单元格类名方法
            selectRow: this.DataGrid.selectRow ? this.DataGrid.selectRow : false, //是否添加行选中 时checkout选中
            defaultSort:this.DataGrid.defaultSort, //默认排序
        }
    },
    methods: {
        onSortChange(column){
            this.$emit('onSortChange' , {'column':column.prop , 'order':column.order})
        },
        clearSelection(val) {
            // console.log(val)
        },
        onSelect(val, row) {
            // console.log(val)
            this.$emit('onSelect', val, row)
        },
        onSelectAll(val) {
            // console.log(val)
            this.$emit('onSelectAll', val)
        },
        /**
         * 表格列表触发CheckBox的事件
         * @param  {array} val
         */
        onSelectionChange(val) {
            this.batch.datas = val
            this.batch.ids = []
            if (val.length) {
                this.batch.flag = false
                for (var i = 0; i < val.length; i++) {
                    this.batch.ids.push(val[i].id)
                }
            } else {
                this.batch.flag = true
            }

            /**
             * 改变CheckBox事件，第一个参数是ID数组，第二个参数二维数组，每个数组是选中的对象
             */
            this.$emit('onSelectionChange', {
                ids: this.batch.ids,
                datas: this.batch.datas
            })

        },

        onHeaderDragend(newWidth, oldWidth, column) {
            this.updateColumn(this.name, column.property, newWidth)
        },

        /**
         * 搜索事件
         * @param data    搜索表单的值
         */
        onSearch(opts) {
            this.$emit('onSearch', opts)
            // console.log(opts)
        },

        /**
         * 删除事件
         * @param  {object || boolean} user  当前信息对象或者为布尔值,为布尔值时，代表是批量删除
         * @param  {number} index 当前列表索引
         */
        onBatchDelete() {
            this.$emit('onClickBtnBatchDelete', {
                ids: this.batch.ids,
                datas: this.batch.datas
            })
        },

        /**
         * 点击按钮事件
         * @param opts  组装的返回参数
         * @param.attr  opts.eventName   string 按钮事件
         * @param.attr  opts.index  number      当点击列表中的按钮时，此值为当前行的索引
         * @param.attr  opts.data   object      当点击列表中的按钮时，此值为当前行数据
         * @param.attr  opts.list   array       当点击列别中的按钮时，此值为当前列表数据
         */
        onBtnEvent(opts) {
            this.$emit(opts.btnInfo.eventName, opts, { ids: this.batch.ids, datas: this.batch.datas })
        },
        /**
         * 改变当前页码事件
         * @param  {number} page 当前页面
         */
        onChangeCurrentPage(page) {
            this.$emit('onChangeCurrentPage', page)
        },

        /**
         * 改变每页显示的数量事件
         * @param  {number} page_size 每页显示的数量
         */
        onChangePageSize(pageSize) {
            this.$emit('onChangePageSize', pageSize)
        },
        set(obj, key, value, event) {
            this.$set(obj, key, value)
            if (event) event.stopPropagation()
        },
        blur(row, field) {
            this.set(row, 'column_opened_state', false);
            field.control.blur(row);
        },
        onSelectRow: function (row) {
            this.$emit('onSelectRow', row);
            if (this.selectRow)
               this.$refs.table.toggleRowSelection(row);
        },
    },

    mounted() {
        this.initColumn(this.name);

        window.onresize = () => {
            return (() => {
                var h = document.documentElement.clientHeight || document.body.clientHeight;
                // console.log(h)
                // console.log( this.fullHeight)
                this.fullHeight = h - 200;
                // console.log(this.fullHeight)
            })()
        }
    },

    /**
     * 接收参数
     * @type {Object}
     */
    props: {
        DataGrid: {
            type: Object,
            default () {
                return {}
            }
        }
    },

    /**
     * 监控参数
     * @type {Object}
     */
    watch: {
        'DataGrid.List' (v) {
            if (v) {
                this.list = v
            }
        },
        'DataGrid.FieldList' (v) {
            if (v) {
                this.fields = v
            }
        },
        'fieldWidthArr' (v) {
          this.fieldWidth = v[this.name]
        },
        'fieldWidth' (v) {
          _.forEach(v, _data => {
            _.forEach(this.fields, (item, rowIndex) => {
              if (item.key === _data.column) {
                this.$set(this.fields[rowIndex], "width", _data.width);
              }
            });
          });
        },
        'DataGrid.ToolBar' (v) {
            if (v) {
                this.toolbar = v
            }
        },
        'DataGrid.Pagination' (v) {
            this.pagination = v
        },
        'DataGrid.Checkbox' (v) {
            this.checkbox = v
        },
        'DataGrid.Expand' (v) {
            this.checkbox = v
        },
        'DataGrid.Search' (v) {
            this.search = v
        },
        'DataGrid.ShowSummary' (v) {
            this.showSummary = v
        },
        'DataGrid.tablesize' (v) {
            this.tablesize = v
        },
        'DataGrid.fixed' (v) {
            this.fixed = v
        },

    }
}



// WEBPACK FOOTER //
// ./src/components/table/ListData.js